import React from "react";
import { ThreadCard } from "./ThreadCard";

const AccessibleThreadCard = function AccessibleThreadCard({
  thread,
  ...props
}) {
  return (
    <div className="rounded-lg">
      <ThreadCard
        {...props}
        thread={thread}
      />
    </div>
  );
};

export { AccessibleThreadCard };